import { render, staticRenderFns } from "./Chamados.vue?vue&type=template&id=31082ea2&scoped=true&"
import script from "./Chamados.vue?vue&type=script&lang=js&"
export * from "./Chamados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31082ea2",
  null
  
)

export default component.exports